import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import myBtnMb from "images/my_btn_mb.png";
import Pagenation from "components/Pagenation";
import { apiWrapper } from "apis/CommonApi";
import * as communityApi from "../../apis/CommunityApi";
import { SystemBoardSearchType, getSystemBoardSearchTypeName } from "utils/common";
import { getDateTime } from "utils/date";
import { API_HOST } from "Constants";

export default function SystemBoardPageComponent() {
  const itemsPerPage = 100;
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("1");
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await communityApi.getNoticePostListByUrl(url);
      } else {
        result = await communityApi.getNoticePostList(
          selectedSearchType,
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const openModal = (id) => {
    apiWrapper(async () => {
      const result = await communityApi.getNoticePost(id);

      const { status, data } = result;
      if (status === true) {
        setSelectedDataSource(data);
      } else {
        alert(`${data}`);
      }
    });

    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  };

  const closeModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(0%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 10);

    //상세보기 창 닫히면 새로고침
    getData(page);
  };

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedSearchType(type);
    setIsSearchListOpen(false);
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const handleDownload = async (file, originalFilename) => {
    //첨부파일 URL -> Blob 변환
    try {
      const response = await fetch(API_HOST + file);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = originalFilename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("첨부파일 URL을 Blob 객체로 변환 실패 : ", error)
    }
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard pb-120">
        <div class="top_board pc">
          <p class="title_board">시스템 공지사항</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                <button className="btn_select" onClick={toggleSelectBox}>
                  <p>{getSystemBoardSearchTypeName(selectedSearchType)}</p>
                  <i className="x-icon"></i>
                </button>
                <ul className="list_member">
                  {Object.values(SystemBoardSearchType).map(
                    (item, index) => (
                      <li onClick={() => handleSearchItemClick(item)}>
                        <p>{getSystemBoardSearchTypeName(item)}</p>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <input
                class=""
                type="text"
                placeholder="검색어를 입력해주세요."
                onChange={handleChangeSearchText}
                onKeyDown={handleSearch}
                defaultValue={searchText}
              />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <img src="" alt="" class="img_logo"> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src={myBtnMb} alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb navi_tab_board">
          <Link class="wrap_navi now" to="/board/system">
            <p class="title_navi">시스템 공지사항</p>
          </Link>
          <Link class="wrap_navi" to="/board/system">
            <p class="title_navi">게시판</p>
          </Link>
        </div>

        <div class="top_board navi_board top_search_board mb">
          <Link class="wrap_navi " to="/">
            <p class="title_navi">시스템 공지사항</p>
          </Link>
          <div class="wrap_right wrap_search_right">
            <input type="text" placeholder="검색어를 입력해주세요." />
            <button class="btn_cancle">취소</button>
          </div>
          <div class="wrap_right wrap_icon_right">
            <button class="btn_page_left">
              <i class="x-icon search_icon"></i>
            </button>
          </div>
        </div>

        <div class="table_board notice_table_board">
          <div class="wrap_table">
            <div class="containerTable noticeSistemTable">
              <ul class="head_table pc">
                <li>
                  <p>순번</p>
                </li>
                <li>
                  <p>제목</p>
                </li>
                <li>
                  <p>첨부</p>
                </li>
                <li>
                  <p>등록 일자</p>
                </li>
                <li>
                  <p>조회</p>
                </li>
              </ul>

              <div class="body_table">
                <div class="inner_table_wrap">
                  {dataSource.results &&
                    dataSource.results.map((item, index) => (
                      <div class="wrap_table_item" onClick={() => openModal(item.id)}>
                        <div class="inner_dep_wrap">
                          <div class="inner_table_item table_item_01">
                            <p class="cont_table_item">{item.id}</p>
                          </div>

                          <div class="inner_table_item table_item_02">
                            <p class="cont_table_item">
                              {item.title}
                            </p>
                          </div>

                          <div class="inner_table_item table_item_03 pc">
                            <div class="inner_dept">
                              <p class="cont_table_item">{item.attachment}</p>
                              {/* <i class="x-icon"></i> */}
                            </div>
                          </div>

                          <div class="mb_inner_dep">
                            <div class="inner_table_item table_item_04">
                              <p class="cont_table_item">{getDateTime(new Date(item.createdDate))}</p>
                            </div>

                            <span class="mb bar"></span>

                            <div class="inner_table_item table_item_05">
                              <p class="cont_table_item">
                                <i class="x-icon mb"></i>{item.viewsCount}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="inner_table_item table_item_03 mb">
                          <div class="inner_dept">
                            <i class="x-icon"></i>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wrap_controll type-start">
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {isModalOpen && (
          <div
            id="modal"
            class="modal centerModal noticeRightModal open"
            onClick={closeModal}
          >
            <div
              className="modal_content NR_modal_content"
              onClick={(e) => e.stopPropagation()}
            >
              <button type="button" className="close_modal" onClick={closeModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>공지사항 상세보기</h2>
              {selectedDataSource && (
                <div class="wrap_detail_cont">
                  <div class="wrap_detail_item right_detail_item">
                    <p class="title_detail">작성자</p>
                    <div class="detail_box">
                      {selectedDataSource.author}
                    </div>
                  </div>
                  <div class="wrap_detail_item right_detail_item">
                    <p class="title_detail">등록일자</p>
                    <div class="detail_box">
                      {getDateTime(new Date(selectedDataSource.createdDate))}
                    </div>
                  </div>
                  <div class="wrap_detail_item">
                    <p class="title_detail">제목</p>
                    <div class="detail_box">
                      {selectedDataSource.title}
                    </div>
                  </div>
                  <div class="wrap_detail_item">
                    <p class="title_detail">내용</p>
                    <div class="detail_box detail_cont_box">
                      {selectedDataSource.content}
                    </div>
                  </div>
                  <div class="wrap_detail_item">
                    <p class="title_detail">첨부파일</p>
                    {selectedDataSource.attachments.map((item, index) => (
                      <button type="button" class="btn_fileDwn" onClick={() => handleDownload(item.file, item.originalFilename)}>
                        {item.originalFilename}
                        <i class="x-icon btn_icon"></i>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
